import {
  getParentConnectSessionContextMockHandler,
  rescheduleParentConnectRequestMockHandler,
} from '@/features/parent-connect-edit-request';

// Mocks for the in-place parent counter-reschedule page
// (`/parent-connect/edit-request`). The slot-listing query is
// already mocked under parent-connect-booking (same endpoint, keyed
// by variant_id), so we only need the session-context fetch + the
// reschedule submit here.
export const parentConnectEditRequestHandlers = [
  getParentConnectSessionContextMockHandler,
  rescheduleParentConnectRequestMockHandler,
];
